export default __webpack_public_path__ + "static/media/SWT1990.34I-43685_-26093_15.d67f99d7.jpg";